module.exports = __webpack_public_path__ + "img/detail_refund.fd2e0f74.svg";